import React from 'react'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, NavItem, NavLink } from 'reactstrap';
import { emailCreateTemplateLink, emailSendEmailLink, emailSentEmailsLink, emailTemplatesLink } from '../routeLinks';

const AdminNavbar = ({ isAdmin = false }) => {
    if (!isAdmin) return <></>

    return <>
        <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
                Email
            </DropdownToggle>
            <DropdownMenu right>
                <DropdownItem href={emailSendEmailLink}>
                    Send Email
                </DropdownItem>
                <DropdownItem href={emailTemplatesLink}>
                    Templates
                </DropdownItem>
                <DropdownItem href={emailSentEmailsLink}>
                    Sent Emails
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
        <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
                Events
            </DropdownToggle>
            <DropdownMenu right>
                <DropdownItem href='/eventlist'>
                    List
                </DropdownItem>
                <DropdownItem href='/eventmanagement'>
                    Management
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
        <NavItem>
            <NavLink href="/site-admin">Site Admin</NavLink>
        </NavItem>
        <div className='vertical-divider' />
    </>
}

export default AdminNavbar;